import $, { event } from "jquery";
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import PostLoginGetApi from '../../../../components/Api/PostLoginGetApi';
import PostLoginPostApi from '../../../../components/Api/PostLoginPostApi';
import init from '../../AccessControl/Check';
import Popup from "../../../../components/Popup";
import { ReactComponent as CloseBtn } from './../../../../assets/icons/close.svg';
import moment from "moment";



const BranchList = () => {
    const pageName = "Branch list";
    const isAccess = init(pageName);


    const [bankList, setBankList] = useState([]);
    const [branchList, setBranchList] = useState([]);
    const [isRefresh, setIsRefresh] = useState(0);

    const [isPopupShow, setIsPopupShow] = useState({
        addInstructions: false,
        editInstructions: false
    });

    const [instruction, setInstruction] = useState({});
    const [editInstruction, setEditInstruction] = useState({});

    const [reqParam, setReqParam] = useState({
        page: 1,
    });

    const [deleteModal, setDeleteModal] = useState({
        isShow: false,
        id: ""
    });

    const [apiData, setApiData] = useState({});

    useEffect(() => {
        PostLoginGetApi("all-branch", reqParam, 1).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    setApiData(responseData["data"]);
                    setBranchList(responseData["data"]["data"]);
                }
            }
        }).catch((err) => {
            console.log(err);
        });
    }, [isRefresh, reqParam]);

    useEffect(()=>{
        // Bank List
        PostLoginGetApi("banks", "", 1).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    setBankList(responseData["data"]);
                }
            }
        }).catch((err) => {
            console.log(err);
        });
    }, []);

    const openModel = (id, data="") => {
        switch (id) {
            case "instructions":
                setIsPopupShow({ addInstructions: true, editInstructions: false });
                break;
            case "instructions-edit":
                setEditInstruction(data);
                setIsPopupShow({ addInstructions: false, editInstructions: true });
                break;
            default:
                break;
        }
    }


    const submitInstructionForm = (event) => {
        event.preventDefault();

        PostLoginPostApi("save-branch", JSON.stringify({ bank_id: instruction?.id, name: instruction?.name }), 4).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    setIsRefresh((prev)=>prev += 1);
                    toast.success(responseData["messages"].toString() ?? "Bank branch added successfully.");
                    closeModel();
                    return;
                }

                toast.error(responseData["messages"].toString() ?? "A problem occur. Please try again.");
            }
        }).catch((err) => {
            console.log(err);
        });


        closeModel();
    }


    const submitEditInstructionForm = (event) => {
        event.preventDefault();

        PostLoginPostApi("update-branch/" + editInstruction?.id , JSON.stringify({ bank_id: editInstruction?.bank_id, name: editInstruction?.name }), 4)
        .then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    setIsRefresh((prev)=>prev += 1);
                    toast.success(responseData["messages"] ?? "Bank update successfully.");
                    closeModel();
                    return;
                }

                toast.error(responseData["message"] ?? "A problem occur. Please try again.");
            }
        }).catch((err) => {
            console.log(err);
        });

        closeModel();
    }

    const closeModel = () => {
        setIsPopupShow({ addInstructions: false, editInstructions: false });
        setInstruction({});
        setEditInstruction({});
    }

    // Delete Category 
    const deleteBranch = (id) => {
        try {
            PostLoginPostApi("branches/" + id, "", 4, 0, 3).then((responseJSON) => {
                var response = JSON.stringify(responseJSON);
                response = JSON.parse(response);

                if (response["status"] === 1) {
                    var responseData = JSON.stringify(response["data"]);
                    responseData = JSON.parse(responseData);
                    if (responseData["code"] === 200) {
                        setDeleteModal(false);
                        toast.success("Bank deleted successfully.");

                        setIsRefresh((prevCounter) => {
                            return prevCounter + 1;
                        });
                        return;
                    }

                    toast.error(responseData["messages"].toString() ?? "A problem occur. Please try again.");
                    return;

                }
            }).catch((error) => {
                toast.error("A problem occur. Please try again.");
            });
        }
        catch (exception) {
            toast.error("A problem occur.");
        }
    }

    const [searchName, setSearchName] = useState("");
    const filterByName = () => {
        if( searchName?.toString().length === 0 ) {
            alert("Please enter name.");
            return;
        }

        setReqParam({ ...reqParam, name:searchName, page: 1 });
    }

    useEffect(()=>{
        if(searchName?.toString().length === 0) {
            setReqParam({ ...reqParam, name: "", page: 1 });
            $("#filter_btn").hide();
            return;
        }

        $("#filter_btn").show();
    },[searchName]);


    const pagination = (next = 1) => {
        if (next === 1) {
            setReqParam({ ...reqParam, page: reqParam.page + 1 });
            return;
        }

        if (reqParam.page > 1) {
            setReqParam({ ...reqParam, page: reqParam.page - 1 });
            return;
        }

        setReqParam({ ...reqParam, page: 1 });
        return;
    }


    const showDropDown = (event) => {
        $(".dropdownDotsHorizontal").hide();
        event.currentTarget.nextSibling.style.display = "block";
    }

    document.addEventListener('scroll', function () {
        $(".dropdownDotsHorizontal").hide();
    }, true);


    $('body').on("click", function (e) {
        if (e.target?.parentElement?.className === "" || e.target?.parentElement?.className === null || e.target?.parentElement?.className === undefined) {
            return;
        }

        if (e.target.parentElement.className.toString().includes("dropdownMenuIconHorizontalButton mt-2") === false) {
            $(".dropdownDotsHorizontal").hide();
        }
    });


    return (
        <div className="custom-container w-full font-montserrat flex -mt-4">

            <div className="custom-container-left float-left custom-scroll-auto min-w-[80%] w-full pr-3 pb-20 text-justify" 
            style={{ boxShadow: "3px 0 0px 0px rgb(0 0 0 / 1%)" }}>

                <div className="text-justify rounded-[5px] py-3">
                    <div className="w-1/3 float-left">
                        <h6 className="text-xl px-4 font-medium pb-0 pl-0 pt-5 mb-5">Here’s your bank branch lists at a glance</h6>
                    </div>

                    <div className="w-2/3 h-[68px] float-left text-right justify-end flex items-center">
                        <input type="search" id="search_by_name" name="search_by_name" value={searchName} onChange={(event)=>{setSearchName(event.currentTarget.value)}} placeholder="Filter by name" className="rounded-md w-[400px] h-[45px] border-gray-500"/>
                        <button id="filter_btn" onClick={filterByName} type="button" className="hidden ml-2 bg-[#00D632] px-5 py-2 rounded-md text-white hover:opacity-75">Filter</button>
                        <Link to="#" onClick={() => openModel("instructions")} className="custom-btn ml-3 mr-1 text-center">Add New Branch</Link>
                    </div>
                </div>


                {/* DATA TABLE */}
                <div className="flex flex-col w-full pt-2">
                    <div className='-m-1.5 pt-0'>
                        <div className='p-1.5 min-w-full inline-block align-middle'>
                            <div className="border rounded-lg shadow ">
                                <table className="min-w-full divide-y divide-gray-200 custom-table-hover">
                                    <thead className='bg-neutral-100'>
                                        <tr className='text-left'>
                                            <th scope="col" className="px-4 py-3 text-center w-16">#</th>
                                            <th scope="col" className="px-6 py-3" style={{width: "350px"}}>Bank Name</th>
                                            <th scope="col" className="px-6 py-3">Branch Name</th>
                                            <th scope="col" className="px-4 py-3 w-56">Create Date</th>
                                            <th scope="col" className="px-4 py-3 w-56">Update Date</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody className='divide-y divide-gray-200'>
                                        {(branchList.length === 0) &&
                                            <tr key="0">
                                                <td className='px-6 py-1 text-center' colSpan={6}>
                                                    <p className='py-4'>No branch available</p>
                                                </td>
                                            </tr>
                                        }

                                        {branchList.map((data, index) => (
                                            (data !== null) &&
                                            <tr key={index}>
                                                <td className='px-4 py-2 border-r-2 text-center font-semibold'>
                                                    {(apiData?.from ?? 0 * 1) + index}
                                                </td>
                                                <td className='px-6 py-1 border-r-2'>{data?.bank_name}</td>
                                                <td className='px-6 py-1 border-r-2'>{data?.name}</td>
                                                <td className='px-4 py-4 border-r-2'>
                                                    {moment(data?.created_at).format("DD MMM, YYYY hh:mm A")}
                                                </td>
                                                <td className='px-4 py-4 border-r-2'>
                                                    {moment(data?.updated_at ?? data?.created_at).format("DD MMM, YYYY hh:mm A")}
                                                </td>
                                                <td className='px-6 py-1 text-center w-[120px]'>
                                                    <button onClick={showDropDown} data-dropdown-toggle="dropdownDotsHorizontal" className="dropdownMenuIconHorizontalButton mt-2">
                                                        <svg className="w-6 h-6" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6 10a2 2 0 11-4 0 2 2 0 014 0zM12 10a2 2 0 11-4 0 2 2 0 014 0zM16 12a2 2 0 100-4 2 2 0 000 4z"></path></svg>
                                                    </button>

                                                    <div className="dropdownDotsHorizontal hidden relative z-50" >
                                                        <div className='absolute -ml-20 -mt-2 border border-[1px solid rgb(245, 245, 245)] bg-white rounded divide-y divide-gray-100 shadow dark:bg-gray-700 dark:divide-gray-600'>
                                                            <ul className="py-1 text-sm text-gray-700 dark:text-gray-200" aria-labelledby="dropdownMenuIconHorizontalButton">
                                                                <li className='border-b-[1px] border-b-slate-100'>
                                                                    <Link to="#" onClick={() => openModel("instructions-edit", data)} className="cursor-pointer block py-2 px-10 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
                                                                        Edit
                                                                    </Link>
                                                                </li>
                                                                <li>
                                                                    <span onClick={() => setDeleteModal({ isShow: true, id: data?.id })} className="cursor-pointer block py-2 px-10 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
                                                                        Delete
                                                                    </span>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>

                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                            </div>


                            {(apiData?.from) !== undefined &&
                                <>
                                    <p className='float-left mt-7'>
                                        {`Showing ${apiData?.from * 1} - ${apiData?.to * 1} out of ${apiData?.total * 1}`}
                                    </p>


                                    {(apiData?.next_page_url !== null && apiData?.next_page_url !== "") &&
                                        <button onClick={() => pagination(1)} className="custom-btn float-right mt-5">
                                            Next Page&nbsp;&nbsp;&rarr;
                                        </button>
                                    }

                                    {(apiData?.prev_page_url !== null && apiData?.prev_page_url !== "") &&
                                        <button onClick={() => pagination(0)} className="custom-btn float-right mt-5 mr-2">
                                            &larr;&nbsp;&nbsp;Previous Page
                                        </button>
                                    }
                                </>
                            }

                        </div>
                    </div>
                </div>


            </div>

            {/* Popup */}
            {(isPopupShow.addInstructions === true) &&
                <div>
                    <Popup content={
                        <form onSubmit={(event) => submitInstructionForm(event)} className="p-5 font-medium">
                            <div className="flex justify-between">
                                <h3 className="text-xl text-black">Add New Branch</h3>
                                <CloseBtn className="cursor-pointer" onClick={closeModel} />
                            </div>

                            <select name="bank_id" id="bank_id" defaultValue={""} onChange={(event) => setInstruction({...instruction, id: event.currentTarget.value})} 
                            className="w-full mt-10 rounded border-solid border border-dark-white text-secondary" required>
                                <option value="" disabled >Choose Bank</option>
                                {bankList.map((data, index) =>
                                    <option key={index} value={data?.id} data-name={data?.name} className="text-black">{data?.name}</option>
                                )}
                            </select>


                            <input type="text" name="name" id="name" value={instruction?.name} onChange={(event) => setInstruction({...instruction, name: event.currentTarget.value})} className='w-full mt-4 mb-5 resize-none border-[#DDD] rounded overflow-hidden focus:outline-none' placeholder="Enter Branch Name *" required />

                            <button type="submit" className="text-white bg-black py-3 text-base rounded cursor-pointer w-full hover:bg-gray-800 disabled:bg-gray-400 disabled:cursor-wait">
                                Save
                            </button>

                        </form>}
                    />
                </div>
            }


            {(isPopupShow.editInstructions === true) &&
                <div>
                    <Popup content={
                        <form onSubmit={(event) => submitEditInstructionForm(event)} className="p-5 font-medium">
                            <div className="flex justify-between">
                                <h3 className="text-xl text-black">Edit Branch</h3>
                                <CloseBtn className="cursor-pointer" onClick={closeModel} />
                            </div>

                            <select name="bank_id" id="bank_id" defaultValue={editInstruction?.bank_id ?? ""} onChange={(event) => setEditInstruction({...editInstruction, bank_id: event.currentTarget.value})} 
                            className="w-full mt-10 rounded border-solid border border-dark-white text-secondary" required>
                                <option value="" disabled >Choose Bank</option>
                                {bankList.map((data, index) =>
                                    <option key={index} value={data?.id} data-name={data?.name} className="text-black">{data?.name}</option>
                                )}
                            </select>


                            <input type="text" name="name" id="name" value={editInstruction?.name} onChange={(event) => setEditInstruction({...editInstruction, name: event.currentTarget.value})} className='w-full mt-4 mb-5 resize-none border-[#DDD] rounded overflow-hidden focus:outline-none' placeholder="Enter Branch Name *" required />

                            <button type="submit" className="text-white bg-black py-3 text-base rounded cursor-pointer w-full hover:bg-gray-800 disabled:bg-gray-400 disabled:cursor-wait">
                                Save
                            </button>

                        </form>}
                    />
                </div>
            }



            {((deleteModal?.isShow === true) && deleteModal.id !== "") ? (
                <>
                    <div
                        className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                        <div className="relative p-4 w-full max-w-md h-full md:h-auto">
                            {/*content*/}
                            <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
                                <button type="button" onClick={() => setDeleteModal(false)} className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-800 dark:hover:text-white" data-modal-toggle="popup-modal">
                                    <svg aria-hidden="true" className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                                    <span className="sr-only">Close modal</span>
                                </button>
                                <div className="p-6 text-center">
                                    <svg aria-hidden="true" className="mx-auto mb-4 w-14 h-14 text-gray-400 dark:text-gray-200" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                                    <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">Are you sure you want to delete this branch ?</h3>
                                    <button data-modal-toggle="popup-modal" type="button" onClick={() => deleteBranch(deleteModal.id)} className="text-white bg-red-600 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center mr-2">
                                        Yes, I'm sure
                                    </button>
                                    <button data-modal-toggle="popup-modal" type="button" onClick={() => setDeleteModal(false)} className="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600">No, cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                </>
            ) : null}
            
        </div>
    );
};

export default BranchList;